var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 361.792,
    height: 149.009,
    viewBox: "0 0 361.792 149.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e0e0e0;}.b{fill:#e6e6e6;}.c{fill:#f0f0f0;}.d{fill:#e9e9e9;}.e{fill:#f4f4f4;}.aa,.ac,.ag,.f,.h,.k,.m,.n,.v{fill:#fff;}.g{fill:#2e353a;}.h,.j,.p,.r{opacity:0.2;}.i{fill:#407bff;}.aa,.ad,.j,.p,.r,.x,.z{isolation:isolate;}.k,.l,.x{opacity:0.4;}.m{font-size:3px;font-family:SegoeUI, Segoe UI;}.n{opacity:0.7;}.o,.p,.u,.v{fill-rule:evenodd;}.o{fill:url(#a);}.p{fill:#3117d6;}.p,.r{mix-blend-mode:multiply;}.q{fill:#ff3b60;}.s{fill:#6a1760;}.t,.u{fill:#967ea5;}.w{fill:url(#b);}.ag,.y,.z{opacity:0.5;}.aa{opacity:0.6;}.ab{fill:#b97964;}.ac{opacity:0.8;}.ad{opacity:0.1;}.ae{fill:none;stroke:#2e353a;stroke-miterlimit:10;stroke-width:2px;}.af{fill:#a24e3f;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#c2b5d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopColor: "#d2c5de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#e4d7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    stopColor: "#efe2ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3e6ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#603082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#2a0e51"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-318 -106.941)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(318 114.511)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.663 67.584)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M393.946,294.259s-3.78-7.4.539-14.691,5.571-9.011,2.818-10.505-4.016,5.834-4.016,5.834a14.888,14.888,0,0,1-.4-10.317c1.917-5.276,3.118-13.87.5-14.792s-.5,10.721-2.771,14.689a31.326,31.326,0,0,1-2.221-8.656c-.314-4.238.177-11-1.89-12.741s-3.391-.535-1.36,8.818a88.092,88.092,0,0,1,2.016,16.954s-4.486-12.268-7.5-12.626-3.007,3.615-.43,7.061,7.547,9.619,8.362,12.8c0,0-4.924-9.232-9.353-6.4s3.855,8.406,7.547,10.421,6.257,14.646,6.257,14.646Z",
    transform: "translate(-376.969 -242.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M400.118,300.31s3.681-7.448-.735-14.682-5.691-8.936-2.958-10.466,4.094,5.78,4.094,5.78a14.89,14.89,0,0,0,.267-10.322c-1.987-5.25-3.3-13.827-.7-14.784s.643,10.713,2.967,14.651a31.327,31.327,0,0,0,2.105-8.684c.257-4.242-.324-11,1.72-12.765s3.383-.58,1.477,8.8a88.1,88.1,0,0,0-1.789,16.98s4.321-12.326,7.327-12.725,3.055,3.575.524,7.055-7.417,9.719-8.19,12.906c0,0,4.8-9.3,9.267-6.527s-3.742,8.456-7.408,10.521-6.06,14.728-6.06,14.728Z",
    transform: "translate(-386.126 -245.427)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.561 49.573)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M408.519,343.187H378.11l2.461,19.518h25.487Z",
    transform: "translate(-378.11 -343.187)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 55.397,
    height: 61.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 50.667,
    height: 56.57,
    transform: "translate(2.438 2.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M82.319,97,68,150.628V121.6L74.552,97Z",
    transform: "translate(-65.562 -94.572)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M91.58,97l-15.1,56.57H73.63L88.732,97Z",
    transform: "translate(-68.423 -94.572)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M159.664,128.36V157.4L156.457,169.5H148.69Z",
    transform: "translate(-106.56 -110.506)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 1.968,
    height: 61.3,
    transform: "translate(26.715)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 53.372,
    height: 1.968,
    transform: "translate(0.962 12.438)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.951, 0.309, -0.309, 0.951, 595.08, 102.2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M77.57,127.21H3.206a3.16,3.16,0,0,1-3.195-3.468L9.386,3.468A3.814,3.814,0,0,1,13.121,0H87.485a3.161,3.161,0,0,1,3.2,3.468L81.306,123.743A3.814,3.814,0,0,1,77.57,127.21Z",
    transform: "translate(0 4.985)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M77.57,127.21H3.206a3.16,3.16,0,0,1-3.195-3.468L9.386,3.468A3.814,3.814,0,0,1,13.121,0H87.485a3.161,3.161,0,0,1,3.2,3.468L81.306,123.743A3.814,3.814,0,0,1,77.57,127.21Z",
    transform: "translate(0 4.985)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.732,9.456H1.121A1.1,1.1,0,0,1,0,8.243L.552,1.212A1.333,1.333,0,0,1,1.857,0H37.469a1.105,1.105,0,0,1,1.117,1.212l-.548,7.031A1.333,1.333,0,0,1,36.732,9.456Z",
    transform: "translate(30.764 3.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M36.732,9.456H1.121A1.1,1.1,0,0,1,0,8.243L.552,1.212A1.333,1.333,0,0,1,1.857,0H37.469a1.105,1.105,0,0,1,1.117,1.212l-.548,7.031A1.333,1.333,0,0,1,36.732,9.456Z",
    transform: "translate(30.764 3.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M5.572,5.576H0L.217,2.788A3.066,3.066,0,0,1,3.221,0h0A2.54,2.54,0,0,1,5.789,2.788Z",
    transform: "translate(47.471)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M5.572,5.576H0L.217,2.788A3.066,3.066,0,0,1,3.221,0h0A2.54,2.54,0,0,1,5.789,2.788Z",
    transform: "translate(47.471)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M71.58,117.171H0L9.133,0h71.58Z",
    transform: "translate(4.989 10.005)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.355 6.703)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M25.518,9.435H2.641A2.606,2.606,0,0,1,.009,6.579L.3,2.856A3.145,3.145,0,0,1,3.376,0H26.253a2.606,2.606,0,0,1,2.632,2.856l-.29,3.722A3.145,3.145,0,0,1,25.518,9.435ZM3.3.969A2.077,2.077,0,0,0,1.268,2.856L.978,6.579A1.721,1.721,0,0,0,2.716,8.465H25.593a2.077,2.077,0,0,0,2.033-1.886l.29-3.722A1.721,1.721,0,0,0,26.177.969Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "l"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M25.518,9.435H2.641A2.606,2.606,0,0,1,.009,6.579L.3,2.856A3.145,3.145,0,0,1,3.376,0H26.253a2.606,2.606,0,0,1,2.632,2.856l-.29,3.722A3.145,3.145,0,0,1,25.518,9.435ZM3.3.969A2.077,2.077,0,0,0,1.268,2.856L.978,6.579A1.721,1.721,0,0,0,2.716,8.465H25.593a2.077,2.077,0,0,0,2.033-1.886l.29-3.722A1.721,1.721,0,0,0,26.177.969Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M20,3.273H.616A.607.607,0,0,1,0,2.606L.153.667A.733.733,0,0,1,.871,0h19.38a.608.608,0,0,1,.614.667l-.151,1.939A.734.734,0,0,1,20,3.273Z",
    transform: "translate(39.696 5.576)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.767 21.201)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M54.265,5.924H0L.462,0H54.726Z",
    transform: "translate(10.07)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.219 12.636)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(1.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0.687 4.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0.344 8.814)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0 13.222)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.31 10.571)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M14.739,14.751H0L1.15,0H15.889Z",
    transform: "translate(0 2.065)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "matrix(0.997, 0.077, -0.077, 0.997, 5.563, 2.991)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.479 34.955)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(1.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0.687 4.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0.344 8.814)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0 13.221)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.57 32.89)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M14.739,14.751H0L1.15,0H15.889Z",
    transform: "translate(0 2.065)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "matrix(0.997, 0.077, -0.077, 0.997, 5.563, 2.991)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.74 57.274)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(1.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0.687 4.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0.344 8.814)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0 13.222)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.83 55.209)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M14.739,14.75H0L1.15,0H15.889Z",
    transform: "translate(0 2.065)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "matrix(0.997, 0.077, -0.077, 0.997, 5.563, 2.991)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 79.592)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(1.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0.687 4.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0.344 8.814)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0 13.221)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.09 77.528)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M14.739,14.75H0L1.15,0H15.889Z",
    transform: "translate(0 2.065)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "m",
    transform: "matrix(0.997, 0.077, -0.077, 0.997, 5.563, 2.991)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M54.265,5.924H0L.462,0H54.726Z",
    transform: "translate(10.07)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.219 12.636)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(1.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0.687 4.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0.344 8.814)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0 13.222)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M14.739,14.751H0L1.15,0H15.889Z",
    transform: "translate(50.31 12.636)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.479 34.955)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(1.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0.687 4.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0.344 8.814)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0 13.221)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M14.739,14.751H0L1.15,0H15.889Z",
    transform: "translate(48.57 34.955)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.74 57.274)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(1.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0.687 4.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0.344 8.814)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0 13.222)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M14.739,14.75H0L1.15,0H15.889Z",
    transform: "translate(46.83 57.274)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 79.592)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(1.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0.687 4.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0.344 8.814)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M36.125,1.529H0L.119,0H36.244Z",
    transform: "translate(0 13.221)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M14.739,14.75H0L1.15,0H15.889Z",
    transform: "translate(45.091 79.592)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(415.855 111.898)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M482.525,123l-1.209,18.487L478.835,179.4l-5.457,83.542-150.393.531-6.739-121.385-.916-16.445L469.852,123.2Z",
    transform: "translate(-315.33 -123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M355.577,130.576l1.51,13.764,86.569-.922L445.144,130Z",
    transform: "translate(-317.282 -123.339)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.773 26.409)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 5.928,
    height: 5.928
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 5.928,
    height: 5.928,
    transform: "translate(0 33.049)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 5.928,
    height: 5.928,
    transform: "translate(0 65.199)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 5.928,
    height: 5.928,
    transform: "translate(0 98.133)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.423 16.894)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M352.351,176.979a4.235,4.235,0,1,1,4.234-4.234A4.239,4.239,0,0,1,352.351,176.979Zm0-7.554a3.319,3.319,0,1,0,3.319,3.32A3.323,3.323,0,0,0,352.351,169.425Z",
    transform: "translate(-348.116 -168.51)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.423 49.586)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M352.351,211.339a4.236,4.236,0,1,1,4.234-4.236A4.241,4.241,0,0,1,352.351,211.339Zm0-7.555a3.319,3.319,0,1,0,3.319,3.319A3.323,3.323,0,0,0,352.351,203.784Z",
    transform: "translate(-348.116 -202.868)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.423 85.139)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M352.351,248.705a4.236,4.236,0,1,1,4.234-4.236A4.24,4.24,0,0,1,352.351,248.705Zm0-7.555a3.319,3.319,0,1,0,3.319,3.319A3.323,3.323,0,0,0,352.351,241.15Z",
    transform: "translate(-348.116 -240.234)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.041 16.894)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M431.824,176.979a4.235,4.235,0,1,1,4.234-4.234A4.239,4.239,0,0,1,431.824,176.979Zm0-7.554a3.319,3.319,0,1,0,3.318,3.32A3.322,3.322,0,0,0,431.824,169.425Z",
    transform: "translate(-427.589 -168.51)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.041 49.586)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M431.824,211.339a4.236,4.236,0,1,1,4.234-4.236A4.241,4.241,0,0,1,431.824,211.339Zm0-7.555a3.319,3.319,0,1,0,3.318,3.319A3.322,3.322,0,0,0,431.824,203.784Z",
    transform: "translate(-427.589 -202.868)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.041 85.139)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M431.824,248.705a4.236,4.236,0,1,1,4.234-4.236A4.24,4.24,0,0,1,431.824,248.705Zm0-7.555a3.319,3.319,0,1,0,3.318,3.319A3.322,3.322,0,0,0,431.824,241.15Z",
    transform: "translate(-427.589 -240.234)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "r",
    transform: "translate(8.008)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 31.593,
    height: 3.964,
    transform: "translate(89.067 33.049)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 14.49,
    height: 3.964,
    transform: "translate(72.741 33.049)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 69.9,
    height: 3.964
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 28.485,
    height: 3.964,
    transform: "translate(0 6.617)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 18.774,
    height: 3.964,
    transform: "translate(89.067)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 44.163,
    height: 3.964,
    transform: "translate(31.542 6.617)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 5.928,
    height: 3.964,
    transform: "translate(72.741)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 5.928,
    height: 3.964,
    transform: "translate(81.303)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 69.9,
    height: 3.964,
    transform: "translate(0 33.049)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 28.485,
    height: 3.964,
    transform: "translate(0 39.665)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 55.689,
    height: 3.964,
    transform: "translate(31.542 39.665)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 31.593,
    height: 3.964,
    transform: "translate(89.067 98.133)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 14.49,
    height: 3.964,
    transform: "translate(72.741 98.133)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 69.9,
    height: 3.964,
    transform: "translate(0 98.133)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 28.485,
    height: 3.964,
    transform: "translate(0 104.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 55.689,
    height: 3.964,
    transform: "translate(31.542 104.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 31.593,
    height: 3.964,
    transform: "translate(89.067 65.199)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 14.49,
    height: 3.964,
    transform: "translate(72.741 65.199)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 69.9,
    height: 3.964,
    transform: "translate(0 65.199)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 28.485,
    height: 3.964,
    transform: "translate(0 71.816)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 55.689,
    height: 3.964,
    transform: "translate(31.542 71.816)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 26.706,
    height: 2.901,
    transform: "translate(15.515 19.529)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 26.706,
    height: 2.901,
    transform: "translate(91.478 87.924)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 26.706,
    height: 2.901,
    transform: "translate(15.515 52.371)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 26.706,
    height: 2.901,
    transform: "translate(15.515 86.668)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 10.225,
    height: 2.901,
    transform: "translate(15.515 91.702)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 26.706,
    height: 2.901,
    transform: "translate(91.511 52.371)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 26.706,
    height: 2.901,
    transform: "translate(91.511 17.268)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 16.331,
    height: 2.901,
    transform: "translate(91.511 21.789)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.074 17.619)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M342.424,175.011h-2.256l-.554,1.331h-1.322l3.069-7.071h.073l3.069,7.071H342.95Zm-.444-1.128-.657-1.655-.683,1.655Z",
    transform: "translate(-338.291 -169.272)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.869 17.888)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M424.391,173.422a1.506,1.506,0,0,1,.3.929,1.742,1.742,0,0,1-.68,1.521,2.84,2.84,0,0,1-1.695.485h-2.266v-6.8h2a2.9,2.9,0,0,1,1.7.439,1.462,1.462,0,0,1,.619,1.271,1.808,1.808,0,0,1-.212.891,1.623,1.623,0,0,1-.6.615A2.143,2.143,0,0,1,424.391,173.422Zm-3-1.087h.813a.731.731,0,0,0,.573-.226.805.805,0,0,0,.2-.559.627.627,0,0,0-.23-.522,1.022,1.022,0,0,0-.639-.18h-.721Zm1.622,2.583a.63.63,0,0,0,.292-.568c0-.48-.383-.721-1.147-.721h-.768v1.48h.86A1.372,1.372,0,0,0,423.014,174.919Z",
    transform: "translate(-420.052 -169.554)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.074 50.527)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M342.424,209.6h-2.256l-.554,1.33h-1.322l3.069-7.071h.073l3.069,7.071H342.95Zm-.444-1.129-.657-1.654-.683,1.654Z",
    transform: "translate(-338.291 -203.857)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.869 50.796)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M424.391,208.008a1.5,1.5,0,0,1,.3.929,1.74,1.74,0,0,1-.68,1.52,2.84,2.84,0,0,1-1.695.485h-2.266v-6.8h2a2.9,2.9,0,0,1,1.7.439,1.459,1.459,0,0,1,.619,1.27,1.812,1.812,0,0,1-.212.892,1.629,1.629,0,0,1-.6.615A2.144,2.144,0,0,1,424.391,208.008Zm-3-1.086h.813a.729.729,0,0,0,.573-.228.8.8,0,0,0,.2-.559.625.625,0,0,0-.23-.521,1.022,1.022,0,0,0-.639-.181h-.721Zm1.622,2.582a.63.63,0,0,0,.292-.568c0-.481-.383-.72-1.147-.72h-.768v1.479h.86A1.372,1.372,0,0,0,423.014,209.5Z",
    transform: "translate(-420.052 -204.14)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.074 85.785)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M342.424,246.653h-2.256l-.554,1.331h-1.322l3.069-7.071h.073l3.069,7.071H342.95Zm-.444-1.128-.657-1.655-.683,1.655Z",
    transform: "translate(-338.291 -240.913)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.869 86.054)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M424.391,245.064a1.5,1.5,0,0,1,.3.928,1.743,1.743,0,0,1-.68,1.522,2.84,2.84,0,0,1-1.695.485h-2.266v-6.8h2a2.9,2.9,0,0,1,1.7.439,1.462,1.462,0,0,1,.619,1.271,1.813,1.813,0,0,1-.212.893,1.629,1.629,0,0,1-.6.614A2.144,2.144,0,0,1,424.391,245.064Zm-3-1.087h.813a.728.728,0,0,0,.573-.226.8.8,0,0,0,.2-.56.628.628,0,0,0-.23-.522,1.022,1.022,0,0,0-.639-.18h-.721Zm1.622,2.583a.632.632,0,0,0,.292-.569c0-.48-.383-.72-1.147-.72h-.768v1.479h.86A1.371,1.371,0,0,0,423.014,246.56Z",
    transform: "translate(-420.052 -241.195)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M354.376,172.864a1.906,1.906,0,1,1-1.906-1.906A1.906,1.906,0,0,1,354.376,172.864Z",
    transform: "translate(-335.812 -151.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M433.849,207.223a1.906,1.906,0,1,1-1.906-1.906A1.906,1.906,0,0,1,433.849,207.223Z",
    transform: "translate(-339.667 -153.401)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M433.849,244.793a1.906,1.906,0,1,1-1.906-1.906A1.906,1.906,0,0,1,433.849,244.793Z",
    transform: "translate(-339.667 -155.224)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(538.98 233.412)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M424.909,255.017l-2.321-10.331,9.789,5.166-5.3.933Z",
    transform: "translate(-422.123 -244.078)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M424.633,255.745l-2.667-11.873L433.2,249.8l-6.06,1.068ZM422.9,245.088l1.975,8.79,1.84-3.586,4.532-.8Z",
    transform: "translate(-421.966 -243.872)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345.833 155.14)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M183.967,257v13.547a10.373,10.373,0,0,1-2.876,7.169l-12.647,13.226h7.16l13.136-12.926a10.374,10.374,0,0,0,3.1-7.393V257Z",
    transform: "translate(-128.672 -238.799)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M191.84,257v13.621a9.956,9.956,0,0,1-.256,2.268,10.284,10.284,0,0,1-2.843,5.126l-13.134,12.927H168.45l12.642-13.228a10.349,10.349,0,0,0,2.878-7.167V257Z",
    transform: "translate(-128.675 -238.799)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M207.871,257v13.621a9.956,9.956,0,0,1-.256,2.268L200,269.814V257Z",
    transform: "translate(-144.705 -238.799)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.628 53.618)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M123.041,329l-10.592,40.368a1.717,1.717,0,0,1-1.659,1.28H91.857a1.019,1.019,0,0,1-.985-1.278L101.47,329H99.436L88.968,368.871a2.988,2.988,0,0,0,2.889,3.745H110.79a3.685,3.685,0,0,0,3.562-2.748L125.076,329Z",
    transform: "translate(-88.868 -329)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "x",
    transform: "translate(0.628 53.618)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M123.041,329l-10.592,40.368a1.717,1.717,0,0,1-1.659,1.28H91.857a1.019,1.019,0,0,1-.985-1.278L101.47,329H99.436L88.968,368.871a2.988,2.988,0,0,0,2.889,3.745H110.79a3.685,3.685,0,0,0,3.562-2.748L125.076,329Z",
    transform: "translate(-88.868 -329)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.648 53.061)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M153.219,372.041l-11.584-44.173-1.9.5,11.453,43.675Z",
    transform: "translate(-139.732 -327.867)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.26 53.061)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M201.219,372.041l-11.584-44.173-1.9.5,11.453,43.675Z",
    transform: "translate(-187.732 -327.867)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "y",
    transform: "translate(25.648 53.061)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M153.219,372.041l-11.584-44.173-1.9.5,11.453,43.675Z",
    transform: "translate(-139.732 -327.867)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "y",
    transform: "translate(49.26 53.061)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M201.219,372.041l-11.584-44.173-1.9.5,11.453,43.675Z",
    transform: "translate(-187.732 -327.867)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M108.856,329h2.036l-1.6,6.085-1.884-.576Z",
    transform: "translate(-97.661 -275.382)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M141.634,327.87l2.632,10.04-2.209-.669-2.327-8.874Z",
    transform: "translate(-114.082 -274.808)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M155.043,329h2.032l-3.335,12.741-1.889-.576Z",
    transform: "translate(-120.241 -275.382)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M194.282,345.8l-2.219-.679-4.334-16.548,1.9-.541Z",
    transform: "translate(-138.471 -274.889)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M96.993,274.294l-9.22-49.8-.124-.753a3.236,3.236,0,0,1,.665-2.662A3.021,3.021,0,0,1,90.68,220h19.913a4.253,4.253,0,0,1,3.963,3.405l.148.84,9.194,49.681-1.935.358-9.223-49.833-.121-.7a2.267,2.267,0,0,0-2.026-1.786H90.68a1.073,1.073,0,0,0-.856.375,1.29,1.29,0,0,0-.237,1.066l.139.824,9.2,49.7Z",
    transform: "translate(-87.591 -220)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "z"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M96.993,274.294l-9.22-49.8-.124-.753a3.236,3.236,0,0,1,.665-2.662A3.021,3.021,0,0,1,90.68,220h19.913a4.253,4.253,0,0,1,3.963,3.405l.148.84,9.194,49.681-1.935.358-9.223-49.833-.121-.7a2.267,2.267,0,0,0-2.026-1.786H90.68a1.073,1.073,0,0,0-.856.375,1.29,1.29,0,0,0-.237,1.066l.139.824,9.2,49.7Z",
    transform: "translate(-87.591 -220)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.385 49.355)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M5,0H37.764a5,5,0,0,1,5,5v.75a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(1.577)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.875)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 45.918,
    height: 2.875,
    rx: 1.438
  }), /*#__PURE__*/React.createElement("rect", {
    className: "aa",
    width: 45.918,
    height: 2.875,
    rx: 1.438
  }))), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M118.653,249.168h-25L89.92,229h25l3.7,19.981Z",
    transform: "translate(-88.775 -224.573)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(359.069 122.151)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M189.421,167.543s-3.142-7.3-3.417-8.082.049-4.733-.189-5.437-3.894-1.166-4.666-1.076-.09,6.2.228,6.682a9.068,9.068,0,0,0,1.4,1.338l2.778,8.381Z",
    transform: "translate(-148.183 -152.937)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.598 8.888)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M164.192,190.5c2.146.339,10.925,1.605,12.887.3,1.585-1.057-2.878-18.181-2.878-18.181l3.972-1.616s9.43,20.765,4.392,25.508c-2.559,2.41-9.749,3.02-20.094,3.02Z",
    transform: "translate(-162.47 -171.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M164.192,190.5c2.146.339,10.925,1.605,12.887.3,1.585-1.057-2.878-18.181-2.878-18.181l3.972-1.616s9.43,20.765,4.392,25.508c-2.559,2.41-9.749,3.02-20.094,3.02Z",
    transform: "translate(-162.47 -171.005)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M168.365,223.088c-1.525.044-3.153.064-4.865.064l1.476-5.652A12.671,12.671,0,0,1,168.365,223.088Z",
    transform: "translate(-139.396 -185.74)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ae",
    x2: 10.412,
    y2: 11.008,
    transform: "translate(37.714 40.363)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M176,245.625s7.945-.246,8.769-.328,4.267-2.05,5-2.131,2.706,3.033,2.951,3.771-5.575,2.706-6.149,2.624a9.071,9.071,0,0,1-1.807-.7L176,249.888Z",
    transform: "translate(-145.747 -198.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M166.5,399.652l3.918-.538.543-9.315-3.913.542Z",
    transform: "translate(-140.922 -273.284)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M169.728,407.488l-4.427-.276a.281.281,0,0,0-.309.249v0l-.434,3.493a.7.7,0,0,0,.645.74c1.546.071,2.288.028,4.237.134a36.66,36.66,0,0,0,5.2.166c1.65-.16,1.448-1.787.735-1.864a10.884,10.884,0,0,1-4.986-2.376A1.109,1.109,0,0,0,169.728,407.488Z",
    transform: "translate(-139.932 -282.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M176.684,408.315a4.838,4.838,0,0,1-1.045-.207.084.084,0,0,1-.065-.074.1.1,0,0,1,.042-.092c.131-.08,1.3-.771,1.769-.555a.35.35,0,0,1,.2.275.492.492,0,0,1-.145.506A1.058,1.058,0,0,1,176.684,408.315Zm.623-.744c-.252-.117-.928.173-1.4.435.7.182,1.216.193,1.414.023a.339.339,0,0,0,.086-.323.167.167,0,0,0-.1-.135Z",
    transform: "translate(-145.53 -282.199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M175.66,407.112a.055.055,0,0,1-.039,0,.105.105,0,0,1-.046-.075c0-.034-.017-1.189.4-1.55a.493.493,0,0,1,.4-.1.355.355,0,0,1,.317.3c.062.434-.577,1.224-.985,1.431A.059.059,0,0,1,175.66,407.112Zm.64-1.535a.266.266,0,0,0-.2.071,2.034,2.034,0,0,0-.335,1.233,1.936,1.936,0,0,0,.746-1.154c0-.054-.035-.121-.165-.144Z",
    transform: "translate(-145.531 -281.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M167.3,390.346l3.914-.537-.312,5.324-3.908.343Z",
    transform: "translate(-141.172 -273.289)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M141.886,290.966l-.956-5.989-21.969-1.314s-2.336,12.464-.541,15.784c3.2,5.927,20.472,2.936,25.525,3.519-3.02,12.352-2.725,36.49-2.725,36.49l7.216.551s5.553-26.011,6.675-38.369C155.869,293.3,148.959,293.506,141.886,290.966Z",
    transform: "translate(-116.146 -219.357)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M163.633,394.07l8.672.571.743-3.714-9.528-.443Z",
    transform: "translate(-139.406 -273.632)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M184.881,393.469l3.945.29,2.471-9-3.94-.285Z",
    transform: "translate(-150.259 -270.579)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M187.69,401.287l-4.272-1.192a.28.28,0,0,0-.354.179v0L181.91,403.6a.7.7,0,0,0,.477.858c1.5.392,2.232.5,4.116,1.014a36.747,36.747,0,0,0,5.054,1.246c1.647.187,1.788-1.446,1.107-1.67a10.878,10.878,0,0,1-4.38-3.363A1.108,1.108,0,0,0,187.69,401.287Z",
    transform: "translate(-148.737 -278.508)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M195,403.715a4.866,4.866,0,0,1-.978-.421.084.084,0,0,1-.049-.086.1.1,0,0,1,.06-.082c.146-.051,1.429-.485,1.847-.174a.35.35,0,0,1,.135.309.492.492,0,0,1-.247.464A1.058,1.058,0,0,1,195,403.715Zm.764-.6c-.222-.167-.943-.025-1.464.133.643.324,1.149.442,1.378.317a.339.339,0,0,0,.152-.3.168.168,0,0,0-.065-.152Z",
    transform: "translate(-154.881 -279.911)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M194.044,402.15a.051.051,0,0,1-.039,0,.1.1,0,0,1-.03-.083c.009-.034.231-1.166.716-1.432a.5.5,0,0,1,.414-.017.354.354,0,0,1,.247.359c-.03.437-.82,1.077-1.261,1.195A.059.059,0,0,1,194.044,402.15Zm.946-1.368a.265.265,0,0,0-.212.028c-.292.157-.494.776-.584,1.136.405-.187.934-.686.971-.973.007-.054-.009-.125-.132-.175Z",
    transform: "translate(-154.88 -278.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M188.5,384.477l3.94.29-1.414,5.143-3.894-.478Z",
    transform: "translate(-151.403 -270.579)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M165.511,340.774l-6.946-2.041s4.147-23.405,8.353-31.522c-.315-.1-.733-.236-1.249-.389-.93-.28-2.164-.63-3.616-1.033-10.094-2.8-30.553-8.048-30.553-8.048l9.346-8.722s37.228,5.677,38,15.485C179.215,309.223,165.511,340.774,165.511,340.774Z",
    transform: "translate(-123.137 -222.079)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M184.7,386.746l8.363,2.365,1.5-3.478-9.227-2.418Z",
    transform: "translate(-150.166 -269.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M171.938,310.565c-.93-.28-2.164-.63-3.616-1.033.29-2.381.3-5.111-.851-6.5-2.278-2.774-8.136-4.4-11.471-4.993-2.789-.492-12.16-1.471-12.16-1.471a73.671,73.671,0,0,1,24.591,2.46C174.575,300.821,173.379,306.827,171.938,310.565Z",
    transform: "translate(-129.407 -225.822)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.273 26.777)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M142.166,208.981s3.188,11.806-.536,37.233c-6.941-.148-18.6-.418-21.984-.492-.084-3.542,2.528-20.9-.526-37.636a45.687,45.687,0,0,1,6.656-.659,84.835,84.835,0,0,1,9.794.212A43,43,0,0,1,142.166,208.981Z",
    transform: "translate(-119.12 -207.371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M142.166,208.981s3.188,11.806-.536,37.233c-6.941-.148-18.6-.418-21.984-.492-.084-3.542,2.528-20.9-.526-37.636a45.687,45.687,0,0,1,6.656-.659,84.835,84.835,0,0,1,9.794.212A43,43,0,0,1,142.166,208.981Z",
    transform: "translate(-119.12 -207.371)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M127.839,237.524c-1.953-.433-4.314-2.327-6.247-4.2-.015-3.325-.162-6.862-.521-10.468C123.805,226.908,131.213,238.267,127.839,237.524Z",
    transform: "translate(-117.837 -188.464)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 27.492)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M116.772,208.824c-7.52,2.71,5.68,23.076,9.779,25.174s24.924-2.3,24.924-2.3l-.82-4.213s-18.426.47-20.124.041-5.733-9.11-8.054-13.209A13.111,13.111,0,0,0,116.772,208.824Z",
    transform: "translate(-114.499 -208.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M116.772,208.824c-7.52,2.71,5.68,23.076,9.779,25.174s24.924-2.3,24.924-2.3l-.82-4.213s-18.426.47-20.124.041-5.733-9.11-8.054-13.209A13.111,13.111,0,0,0,116.772,208.824Z",
    transform: "translate(-114.499 -208.824)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.68 45.779)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M185,246l1.066,5.591,1.968-.672L187.3,246Z",
    transform: "translate(-185 -246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M185,246l1.066,5.591,1.968-.672L187.3,246Z",
    transform: "translate(-185 -246)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.781 7.826)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M185.634,172.747l5.293-2.095-1.029-1.807-4.694,1.647Z",
    transform: "translate(-185.204 -168.846)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M185.634,172.747l5.293-2.095-1.029-1.807-4.694,1.647Z",
    transform: "translate(-185.204 -168.846)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M130.241,206.655s.14,2.3,4.653,4.512l3.121-2.256s.89,5.761,1.449,10.065c0,0-.037-6.887-.631-9.531l2.387.847s-2.034-3.491-5.49-4.29A7.074,7.074,0,0,0,130.241,206.655Z",
    transform: "translate(-122.497 -179.776)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M133.855,185.164c.551,3.163,1.043,8.948-1.205,11L139.239,198l3.205-1.616c-3.5-.915-3.35-3.522-2.686-5.957Z",
    transform: "translate(-123.721 -169.311)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M139.843,189.524l3.493,3.114a10.312,10.312,0,0,0-.339,1.732c-1.338-.221-3.148-1.736-3.261-3.143A4.625,4.625,0,0,1,139.843,189.524Z",
    transform: "translate(-127.303 -171.526)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M143.987,165.395c-1.431,1.554-.2,3.33,4.373,5.49,1.087-2.4.423-6.395-1.053-7.093S145.237,164.047,143.987,165.395Z",
    transform: "translate(-129.195 -158.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M130.955,169.507c1.161,4.117,1.633,6.582,4.2,8.269,3.866,2.533,8.6-.492,8.7-4.875.079-3.935-1.83-10.01-6.272-10.783a5.834,5.834,0,0,0-6.626,7.389Z",
    transform: "translate(-122.74 -157.555)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M144.357,176.082c.074.339.315.576.536.526s.339-.359.266-.7-.31-.576-.531-.531S144.308,175.743,144.357,176.082Z",
    transform: "translate(-129.663 -164.336)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M152.2,174.391c.074.339.315.576.536.526s.344-.359.271-.7-.315-.576-.536-.526S152.124,174.051,152.2,174.391Z",
    transform: "translate(-133.642 -163.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M149.73,176a12.419,12.419,0,0,0,2.253,2.553,2.007,2.007,0,0,1-1.559.654Z",
    transform: "translate(-132.399 -164.657)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M141.428,173.307a.192.192,0,0,1-.236-.271,2.016,2.016,0,0,1,1.446-1.176.2.2,0,0,1,.229.158l0,.014a.212.212,0,0,1-.172.231h0a1.607,1.607,0,0,0-1.131.94A.212.212,0,0,1,141.428,173.307Z",
    transform: "translate(-128.052 -162.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M153.416,170.525a.212.212,0,0,1-.207-.074,1.623,1.623,0,0,0-1.318-.659.205.205,0,0,1-.039-.408,2.036,2.036,0,0,1,1.677.817.2.2,0,0,1-.032.283l0,0A.247.247,0,0,1,153.416,170.525Z",
    transform: "translate(-133.384 -161.293)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M129.135,168.789c2.1.246,2.312,2.4.246,7.01-2.386-1.112-4.486-4.585-3.812-6.07S127.3,168.578,129.135,168.789Z",
    transform: "translate(-120.058 -160.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M128.365,182.02a4.068,4.068,0,0,0,2.405,1.968c1.368.4,2.066-.822,1.7-2.12-.33-1.171-1.441-2.789-2.819-2.617A1.813,1.813,0,0,0,128.365,182.02Z",
    transform: "translate(-121.414 -166.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M125.806,162.927s-1.04-1.341,1-4.018,6.96-3.5,10.75-2.759,1.535,4.919.183,5.616l.164-.656a11.292,11.292,0,0,1-4.669,1.271l.743-.7S128.018,163.228,125.806,162.927Z",
    transform: "translate(-120.109 -154.438)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.899 15.556)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M147.659,184.689a10.643,10.643,0,0,0-.14,1.53c-.09.014-.179.028-.269.037-1.216.162-1.833-.165-2.149-.577a1.582,1.582,0,0,1-.288-.692,1.536,1.536,0,0,1-.021-.428,5.779,5.779,0,0,0,2.451.177C147.5,184.715,147.659,184.689,147.659,184.689Z",
    transform: "translate(-144.786 -184.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M147.244,184.737l-.053.45a3.645,3.645,0,0,1-2.377-.2,1.536,1.536,0,0,1-.021-.428A5.779,5.779,0,0,0,147.244,184.737Z",
    transform: "translate(-144.786 -184.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M147.576,187.389c-1.216.162-1.833-.165-2.149-.577a3.936,3.936,0,0,1,1.386.089A1.479,1.479,0,0,1,147.576,187.389Z",
    transform: "translate(-145.112 -185.692)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.744 24.911)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M132.577,203.577a28.6,28.6,0,0,0,5.438,3.283,4.918,4.918,0,0,0,.515-3l2.691,1.875a6.641,6.641,0,0,1,0,3.447l-3.205-1.83-3.033,2.214s-4.482-1.3-4.741-4.02Z",
    transform: "translate(-130.241 -203.577)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M132.577,203.577a28.6,28.6,0,0,0,5.438,3.283,4.918,4.918,0,0,0,.515-3l2.691,1.875a6.641,6.641,0,0,1,0,3.447l-3.205-1.83-3.033,2.214s-4.482-1.3-4.741-4.02Z",
    transform: "translate(-130.241 -203.577)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.939 50.14)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 50.181,
    height: 2.591,
    rx: 1.167,
    transform: "translate(0.162)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M203.175,255.443v1.441c0,.32-.089.576-.4.576H153.738c-.32,0-.738-.256-.738-.576v-1.441c0-.315.418-.443.738-.443h49.034C203.086,255,203.175,255.128,203.175,255.443Z",
    transform: "translate(-153 -254.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M173.66,255.443v1.441c0,.32-.108.576-.423.576h-19.5c-.32,0-.738-.256-.738-.576v-1.441c0-.315.418-.443.738-.443h19.5C173.552,255,173.66,255.128,173.66,255.443Z",
    transform: "translate(-153 -254.934)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExam);
export default __webpack_public_path__ + "static/media/exam.16571683cadf29644c17c6d160cd1aa0.svg";
export { ForwardRef as ReactComponent };